export const getInvitationDetails = (service, invitation_token) => {
  return service.get(`/invitation-details?it=${invitation_token}`);
};

export const processInvitation = (service, invitation_token, status) => {
  return service.post("/process-invitation", {
    it: invitation_token,
    status: status,
  });
};
